import { createContext, useState, useEffect } from "react";
import { MetricMetadata } from "../services/types";
import { fetchMetricMetadataByOrg } from "../utils/dashboardUtils";
import { useOrgId } from "./OrgIdContext";

// Define the shape of the context
interface MetadataContextType {
  metadata: MetricMetadata[] | null;
  loading: boolean;
}
// Create the context with default values
const MetadataContext = createContext<MetadataContextType>({
    metadata: null,
    loading: false,
});

export const MetadataProvider = ({ children }: { children: React.ReactNode }) => {
  const orgId = useOrgId();
  const [metadata, setMetadata] = useState<MetricMetadata[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchMetadata = async () => {
      if (!orgId) return;
      
      setLoading(true); // Start loading

      try {
        const response = await fetchMetricMetadataByOrg(orgId);
        console.log('fetched metadata from context:', response.data);
        setMetadata(response.data);
      } catch (error) {
        console.error("Error fetching metric metadata:", error);
      } finally {
        setLoading(false); // End loading
      }
    };
    fetchMetadata();
  }, [orgId]);

  return (
    <MetadataContext.Provider value={{ metadata, loading }}>
      {children}
    </MetadataContext.Provider>
  );
};

export default MetadataContext;